var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:{link : _vm.newLink},attrs:{"href":_vm.merchantOrderLine.product_url,"target":"_blank","rel":"noopener noreferrer"},on:{"click":_vm.clickHandler}},[_vm._v("#"+_vm._s(_vm.merchantOrderLine.sku)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }